import Layout from "@/components/Layout";
import PageHead from "@/components/PageHead";

export default function TermsPage() {
  return (
    <Layout>
      <PageHead
        title="Terms of Service"
        description="Terms of Service for MOTUS Bug Board, operated by Don Norman Associates."
        path="/terms"
      />
      <div className="max-w-3xl mx-auto py-8">
        <h1 className="text-3xl font-extrabold text-slate-900 dark:text-white tracking-tight mb-2">
          Terms of Service
        </h1>
        <p className="text-sm text-slate-500 mb-8">Last updated: May 28, 2026</p>

        <div className="prose prose-slate dark:prose-invert max-w-none space-y-8 text-slate-700 dark:text-slate-300">

          <section>
            <h2 className="text-xl font-bold text-slate-900 dark:text-white mb-3">1. About This Service</h2>
            <p>
              MOTUS Bug Board is operated by <strong>Don Norman Associates</strong> ("we", "us", or "our"). This tool helps
              trucking carriers track known bugs in the FMCSA's MOTUS registration system and submit their own bug
              reports. Don Norman Associates is an independent consulting firm and is <strong>not affiliated with,
              endorsed by, or acting on behalf of the FMCSA</strong>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 dark:text-white mb-3">2. Acceptance of Terms</h2>
            <p>
              By accessing or using MOTUS Bug Board, you agree to be bound by these Terms of Service. If you do not
              agree to these terms, please do not use this service. We may update these terms from time to time; continued
              use after changes are posted constitutes acceptance of the revised terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 dark:text-white mb-3">3. Acceptable Use</h2>
            <p>You agree to use MOTUS Bug Board only for lawful purposes and in a manner consistent with its intent. You agree not to:</p>
            <ul className="list-disc pl-6 space-y-1 mt-2">
              <li>Submit false, misleading, or malicious reports</li>
              <li>Attempt to disrupt or overload the service</li>
              <li>Use automated means to scrape or access the service without permission</li>
              <li>Impersonate any person or entity</li>
              <li>Submit content that is unlawful, harassing, or otherwise harmful</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 dark:text-white mb-3">4. User-Submitted Content</h2>
            <p>
              When you submit a bug report or other content through this service, you grant Don Norman Associates a
              non-exclusive, royalty-free license to use, store, and display that content for the purposes of operating
              and improving MOTUS Bug Board. You represent that you have the right to submit the content and that it does
              not violate any third-party rights.
            </p>
            <p className="mt-2">
              We do not sell your submitted reports to third parties. Content you submit may be shared in aggregated or
              anonymized form to help identify system-wide issues for our clients and the broader carrier community.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 dark:text-white mb-3">5. No FMCSA Affiliation</h2>
            <p>
              MOTUS Bug Board is a third-party tool. We have no ability to modify your FMCSA account, resolve issues
              directly with MOTUS, or act on behalf of any government agency. Information gathered through this service
              is used solely to track and communicate about known issues to our consulting clients.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 dark:text-white mb-3">6. Service Availability</h2>
            <p>
              We provide MOTUS Bug Board on an "as available" basis and do not guarantee uninterrupted or error-free
              access. We reserve the right to modify, suspend, or discontinue the service at any time without notice.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 dark:text-white mb-3">7. Disclaimer of Warranties</h2>
            <p>
              MOTUS Bug Board is provided <strong>"as is"</strong> without warranty of any kind, express or implied,
              including but not limited to warranties of merchantability, fitness for a particular purpose, or
              non-infringement. Don Norman Associates does not warrant the accuracy, completeness, or timeliness of
              any information presented on this service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 dark:text-white mb-3">8. Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by applicable law, Don Norman Associates shall not be liable for any
              indirect, incidental, special, consequential, or punitive damages arising out of or relating to your use
              of, or inability to use, this service — even if we have been advised of the possibility of such damages.
              Our total liability to you for any claim arising under these terms shall not exceed the amount you paid to
              use this service (which, as a free service, is zero).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 dark:text-white mb-3">9. Governing Law</h2>
            <p>
              These Terms of Service are governed by and construed in accordance with applicable law. Any disputes
              arising from these terms or your use of the service shall be resolved in a manner consistent with
              applicable law.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 dark:text-white mb-3">10. Contact</h2>
            <p>
              If you have questions about these Terms of Service, please contact Don Norman Associates through our
              company website at{" "}
              <a
                href="https://donnormanassociates.com"
                target="_blank"
                rel="noopener noreferrer"
                className="dna-link underline"
              >
                donnormanassociates.com
              </a>
              .
            </p>
          </section>

        </div>
      </div>
    </Layout>
  );
}
